import React from 'react'
import '../css/loader.css'
import '../css/general.css'

const Loader = () => {
  return (
    <div className="min-height pos-rel">
      <span class="loader"></span>
    </div>
  )
}

export default Loader
